/**
 * Author: Andrey Morozov
 * Confidential. Proprietary code. Do not distribute without authorization.
 *
 * TopBar.tsx — To\1 \2ar (services/operator-web-app).
 */

import { PresenceControls } from '@/features/presence';
import { CallControlCluster } from '@/features/call';
import { ThemeToggle } from '@/components/ThemeToggle';
import { LocaleSwitcher, useTranslation } from '@/i18n';

/**
 * TopBar: operator status, call timer, call controls (mute/hold/transfer/end).
 * Plan: 02_information_architecture, 14_wireframes — sticky, always visible.
 */
export function TopBar() {
  const t = useTranslation();
  return (
    <header
      className="glass-panel flex-shrink-0 h-12 flex items-center justify-between px-4 gap-4"
      style={{ borderRadius: 0, borderLeft: 'none', borderRight: 'none', borderTop: 'none' }}
      role="banner"
    >
      <div className="flex items-center gap-3 min-w-0">
        <span
          className="font-semibold truncate"
          style={{ color: 'rgba(34, 197, 94, 1)', fontFamily: 'var(--font-display)' }}
        >
          {t('shell.workspace')}
        </span>
        <CallControlCluster />
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <LocaleSwitcher />
        <ThemeToggle />
        <PresenceControls />
      </div>
    </header>
  );
}
